/**
 * Returns today if it's a business day, otherwise the next available business day.
 * Skips weekends and closed dates.
 * @param closedDates Set of date strings in YYYY-MM-DD format
 */
export function getNextAvailableDate(closedDates: Set<string> = new Set()): Date {
  const date = new Date();

  // Skip weekends and closed dates (max 30 iterations as safety)
  for (let i = 0; i < 30; i++) {
    const day = date.getDay();
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const dateStr = `${yyyy}-${mm}-${dd}`;

    if (day !== 0 && day !== 6 && !closedDates.has(dateStr)) {
      return date;
    }
    date.setDate(date.getDate() + 1);
  }

  return date;
}
